import { C } from "./styles";

const space = "\xa0\xa0\xa0\xa0";
const shorterSpace = "\xa0\xa0\xa0";

export default {
    cs: <>
        <li>{W("using", "p")} {W("System", "y")};</li>
        <li><br /></li>
        <li>{W("namespace", "p")} {W("WelcomePage", "y")} {"{"}</li>
        <li>{space}{W("class", "p")} {W("Program", "y")} {"{"}</li>
        <li>{space}{space}{W("static void", "p")} {W("Main", "b")}({W("string", "p")}[] {W("args", "y")}) {"{"}</li>
        <li>{space}{space}{space}{W("Console", "y")}.{W("Write", "b")}({W('"Hello, my name is "', "g")});</li>
        <li>{space}{space}{space}{W("Console", "y")}.{W("Read", "b")}();</li>
        <li>{space}{space}{"}"}</li>
        <li>{space}{"}"}</li>
        <li>{"}"}</li>
    </>,
    rs:
        <>
            <li>
                {W("use", "p")} {W("std", "y")}
                {"::{"}
                {W("self", "y")}, {W("io", "y")}::{"{"}
                {W("Write", "y")}
                {"}};"}
            </li>
            <li>
                <br />
            </li>
            <li>
                {W("fn", "p")} {W("main", "b")}
                {"() -> () {"}
            </li>
            <li>
                {space}{W("let mut", "p")} {W("string")}:{" "}
                {W("String", "y")} = {W("String", "y")}::{W("new", "b")}();
            </li>
            <li>
                <br />
            </li>
            <li>
                {space}{W("print!", "o")}(
                {W('"Hello, my name is "', "g")});
            </li>
            <li>
                <br />
            </li>
            <li>
                {space}{W("let", "p")} {W("_")} ={" "}
                {W("std", "y")}::{W("io", "y")}::{W("stdout", "b")}().
                {W("flush", "b")}();
            </li>
            <li>
                {space}{W("std", "y")}::{W("io", "y")}::{W("stdin", "b")}()<br />
                {space}{space}{space}.{W("read_line", "b")}(&{W("mut", "p")}{" "}{W("string")})<br />
                {space}{space}{space}.{W("expect", "b")}({W('"Error :("', "g")});
            </li>
            <li><br /></li>
            <li>{shorterSpace}{W("return", "p")} ();</li>
            <li>{"}"}</li>
        </>
    ,
    jsts: <>
        <li>
            {W("process")}.{W("stdout")}.{W("write", "b")}(
            {W('"Hello, my name is "', "g")});
        </li>
        <li>
            <br />
        </li>
        <li>
            {W("const", "p")} {W("stdin", "y")} = {W("process")}.
            {W("openStdin", "b")}();
        </li>
        <li>
            <br />
        </li>
        <li>
            {W("stdin", "y")}.{W("addListener", "b")}({W('"data"', "g")},
            ({W("_d")}) {W("=>", "p")} {W("process")}.{W("exit", "b")}(
            {W("0", "o")}));
        </li>
    </>,
}

function W(t, c) {
    switch (c) {
        case "p":
            return <C.P>{t}</C.P>;
        case "y":
            return <C.Y>{t}</C.Y>;
        case "b":
            return <C.B>{t}</C.B>;
        case "o":
            return <C.O>{t}</C.O>;
        case "g":
            return <C.G>{t}</C.G>;
        default:
            return <C.R>{t}</C.R>;
    }
}
